import React from 'react'

function TechSelectHFM() {
  return (
    <embed src="\pdfs\D2.5.2.1_LG-Z-M-LB_LG-ZUM-M-LB_Dezentrales_Lueftungsgeraet_fuer_Mischlueftung-liegend_03.2014_kr.pdf" width="100%" height="2100px" />
  )
}

export default TechSelectHFM